import script from "./RewardSettingsQuery.vue?vue&type=script&lang=js"
export * from "./RewardSettingsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__